import React from 'react'
import {history} from '../../history';
import {inject, observer} from 'mobx-react';

function login() {
    history.push('/login')
}

export default inject('alert')(
    observer(({alert}) => {
            let {
                title,
                msg,
                btnVal,
                cancelBtnVal,
                justSure,
                extraVal,
                extra,
                isShow,
                render,
                delHandle,
                cancelHandle,
                sureHandle,
                type,
                cls
            } = alert;
            if (type === 'timeout') {
                msg = '登陆超时 请重新登录'
            }
            let btnHtml = '', deleteHtml = '';
            const h = (fn) => () => {
                if (fn) fn();
                alert.hide();
            };
            if (type === 'confirm') {
                btnHtml = (
                    <div className={`btns ${justSure ? 'single' : ''}`}>
                        {
                            justSure ? '' : <div onClick={h(cancelHandle)}>
                                {cancelBtnVal}</div>
                        }
                        <div onClick={h(sureHandle)}>
                            {btnVal}
                        </div>
                        {
                            justSure||!extraVal ? '' : <div className={'re'} onClick={h(extra)}>
                                {extraVal}</div>
                        }
                    </div>)
            } else if (type === 'timeout') {
                btnHtml = (
                    <div className='goLogin' onClick={h(login)}>
                        重新登陆
                    </div>
                )
            } else if (type === 'message') {
                deleteHtml = (
                    <div className='delete' onClick={h(delHandle)}>✕</div>
                )
            }
            const rd = render && render(h());
            const rs = rd||msg;
            const block =typeof rs==='string'&&/Failed to fetch/gi.test(rs)
            return (
                <div className={`window ${(isShow&&!block) ? 'show' : ''}`}>
                    <div className={'window_con ' + cls}>
                        {(title || deleteHtml) ?
                            <div className='title'>
                                {title}
                                {deleteHtml}
                            </div> : ''}
                        <div className='msg'>{rd || msg}</div>
                        {rd ? '' : btnHtml}
                    </div>
                </div>
            )
        }
    ));
